import { render, staticRenderFns } from "./importDoctor.vue?vue&type=template&id=0dc79fd6&scoped=true"
import script from "./importDoctor.vue?vue&type=script&lang=js"
export * from "./importDoctor.vue?vue&type=script&lang=js"
import style0 from "./importDoctor.vue?vue&type=style&index=0&id=0dc79fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc79fd6",
  null
  
)

export default component.exports